// /src/pages/SeedBank.jsx
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Sprout, AlertTriangle } from 'lucide-react'

const SeedBank = () => {
  const location = useLocation()
  
  // Scroll to top when location changes (route navigation)
  useEffect(() => {
    // Multiple aggressive approaches to ensure scroll to top
    const scrollToTop = () => {
      // Method 1: Immediate scroll
      window.scrollTo(0, 0)
      
      // Method 2: Document element scroll
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      
      // Method 3: Force scroll after a brief delay
      setTimeout(() => {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 50)
      
      // Method 4: Smooth scroll as final attempt
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 100)
    }
    
    // Execute immediately
    scrollToTop()
    
    // Also execute after a longer delay to catch any late overrides
    setTimeout(scrollToTop, 200)
    setTimeout(scrollToTop, 500)
  }, [location.pathname])
  return (
    <div className="min-h-screen bg-forest-50 flex flex-col items-center justify-center text-center px-4">
      <div className="max-w-xl mx-auto py-20">
        <div className="flex flex-col items-center mb-6">
          <Sprout className="w-16 h-16 text-primary-600 mb-2" />
          <h1 className="text-4xl font-bold text-forest-900 mb-2">SeedBank</h1>
        </div>
        <AlertTriangle className="w-10 h-10 text-earth-500 mx-auto mb-4" />
        <p className="text-xl text-forest-700 mb-4">
          <strong>Coming Soon!</strong>
        </p>
        <p className="text-lg text-forest-600 mb-6">
          Seed preservation ensures we can regrow plants after disasters or climate events. As weather becomes more unpredictable, protecting and cataloging seeds is more important than ever. Our global seed bank feature is coming soon!
        </p>
        <p className="text-forest-500">
          Stay tuned for updates!
        </p>
      </div>
    </div>
  )
}

export default SeedBank 